import { useSelector } from 'react-redux';

import { selectQuotationsCountByStatus } from '../services/selectors';

export const useQuotationsCountByStatus = () => useSelector(selectQuotationsCountByStatus);
